import React from 'react';

import bdAuth from '@bd-uikit-web/js-helpers/bdAuth';
import {Show} from '@bd-uikit-web/React/Utils';
import SimpleModal from '@bd-uikit-web/React/SimpleModal';
import rootDispatcher from '@bd-uikit-web/js-helpers/rootDispatcher';

export default class AuthOverlay extends React.Component {
  constructor() {
    super();
    this.logoPath = '/assets/img/bd-logo-dark-bg.svg';
    this.customRegisterPath = null;
    this.state = {
      loading: true,
      showRedirectErrorMessage: false,
    };
  }

  componentWillMount() {
    const tokenLogin = bdAuth.getTokenLogin();

    if (tokenLogin.paramsValid) {
      tokenLogin.authenticate()
        .then(() => this.checkUser())
        .then(() => this.redirect())
        .catch(() => this.setState({loading: false}));
      return;
    }

    if (bdAuth.isAuthenticated()) {
      this.checkUser()
        .then(() => this.redirect());
      return;
    }

    location.href = bdAuth.getLoginURL(this.customRegisterPath);
  }

  checkUser() {
    const user = bdAuth.getUser();
    if (!user) {
      return bdAuth.storeUser()
        .then(() => this.setState({loading: false}));
    }
    this.setState({loading: false});
    return Promise.resolve();
  }

  getRedirectErrorMessage() {
    return (
      <div>Permissions error message</div>
    );
  }

  redirectCheck() {
    return true;
  }

  redirect() {
    if (!this.redirectCheck()) {
      this.setState({showRedirectErrorMessage: true});
      return;
    }

    rootDispatcher.dispatch('LOGIN');
  }

  render() {
    return (
      <div className="bg-image" style={{backgroundImage: 'url(/assets/img/commercial-webapp.jpg)'}}>
        <SimpleModal open>
          <div className="modal__body">

            <div className="logo-text">
              <img src={this.logoPath} alt="" />
            </div>

            <Show
              condition={this.state.showRedirectErrorMessage}
              className="info-box info-box--multiline info-box--error"
            >
              {this.getRedirectErrorMessage()}
            </Show>

            <Show condition={this.state.loading} className="spinner spinner--big" />
          </div>
        </SimpleModal>
      </div>
    );
  }
}
